import React, { useEffect, useState } from 'react';
// import { doc, getDoc } from 'firebase/firestore';
// import { db, localDb } from '../../firebase/config';
import { useAuth } from '../../context/AuthContext';
import useAutoLogout from '../../hooks/useAutoLogout';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Box,
  Typography,
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

const AutoLogoutWrapper = ({ children }) => {
  const { currentUser } = useAuth();
  const [timeoutMinutes, setTimeoutMinutes] = useState(30); // Default 30 minutes

  useEffect(() => {
    const fetchUserSettings = async () => {
      if (currentUser) {
        try {
          // TODO: Replace with centralized API call
          // GET /api/user/settings or GET /api/user/profile
          // Should return: { settings: { autoLogoutMinutes: number } }

          /* COMMENTED OUT - Pattern A Migration
           * Pattern A: User settings stored in central Firestore (paymentgateway-ab783)
           * This local Firestore read should be replaced with Central API call
           *
          const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
          if (userDoc.exists()) {
            const userData = userDoc.data();
            // Check if user has a custom auto-logout timeout setting
            if (userData.settings?.autoLogoutMinutes !== undefined) {
              setTimeoutMinutes(userData.settings.autoLogoutMinutes);
            }
          }
          */

          // Default: 30 minutes until API integration
        } catch (error) {
          console.error('Error fetching user settings:', error);
        }
      }
    };

    fetchUserSettings();
  }, [currentUser]);
  
  // Use the auto-logout hook with the configured timeout
  const {
    showWarning,
    remainingTime,
    formatTime,
    handleStayLoggedIn,
    handleLogout,
  } = useAutoLogout(timeoutMinutes);
  
  return (
    <>
      {children}
      {timeoutMinutes > 0 && (
        <Dialog
          open={showWarning}
          onClose={handleStayLoggedIn}
          aria-labelledby="auto-logout-dialog-title"
          aria-describedby="auto-logout-dialog-description"
          maxWidth="sm"
          fullWidth
        >
        <DialogTitle id="auto-logout-dialog-title">
          <Box display="flex" alignItems="center" gap={1}>
            <WarningIcon color="warning" />
            <Typography variant="h6">Session Timeout Warning</Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="auto-logout-dialog-description">
            <Box textAlign="center" py={2}>
              <Typography variant="body1" gutterBottom>
                You've been inactive for a while. Your session will expire in:
              </Typography>
              <Typography variant="h3" color="error" sx={{ my: 2, fontWeight: 'bold' }}>
                {formatTime(remainingTime)}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Would you like to stay logged in?
              </Typography>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
          <Button 
            onClick={handleLogout} 
            color="inherit"
            variant="outlined"
          >
            Log Out Now
          </Button>
          <Button 
            onClick={handleStayLoggedIn} 
            variant="contained" 
            color="primary"
            autoFocus
          >
            Stay Logged In
          </Button>
        </DialogActions>
      </Dialog>
      )}
    </>
  );
};

export default AutoLogoutWrapper;